import { render, staticRenderFns } from "./ReportsContract.vue?vue&type=template&id=a4c76664&"
import script from "./ReportsContract.vue?vue&type=script&lang=js&"
export * from "./ReportsContract.vue?vue&type=script&lang=js&"
import style0 from "./ReportsContract.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports